export default __webpack_public_path__ + "static/media/unsplash_k1xf2D7jWUs.0773c326.svg";